<template>
  <div class="dropdown-menu dropdown-menu-right pt-0 mr-1" aria-labelledby="dropdownMenuButton">

    <div class="media align-items-center p-3 arrow top rounded-top text-white">
      <img v-bind:src="$store.state.host.avatar" class="user-avatar shadow mr-2 rounded-circle" style="width:4rem;">
      <div class="media-body">
        <span class="bold color-1 user-name text-overflow text-capitalize">
          {{ $store.state.host.name.first }} {{ $store.state.host.name.last }}
        </span>
        <p class="small user-info text-overflow mb-0 op-5">
          {{ $store.state.host.email }}
        </p>
      </div>
    </div>

    <ul class="dropdown-body list list-group list-group-flush">
      <li class="list-group-item list-group-item-action pt-2 pb-2">
        <router-link :to="{name: 'profile'}" class="nav-link">
          <i class="mr-3 fas fa-user" style="width:2rem;"></i>
          Profil
        </router-link>
      </li>
      <li class="list-group-item list-group-item-action pt-2 pb-2">
        <a href="#" class="nav-link">
          <i class="mr-3 fas fa-cogs" style="width:2rem;"></i>
          Nastavitve
        </a>
      </li>
      <li class="list-group-item list-group-item-action pt-2 pb-2">
        <a href="#" class="nav-link">
          <i class="mr-3 fas fa-life-ring" style="width:2rem;"></i>
          Pomoč
        </a>
      </li>
    </ul>

    <div class="dropdown-footer list-group-item list-group-item-action pt-2 pb-2">
      <button class="btn btn-link nav-link" @click="$logout">
        <i class="mr-3 fas fa-sign-out-alt" style="width:2rem;"></i>
        Log out
      </button>
    </div>

    <!--<a class="dropdown-item" href="#">
      <i class="mr-1 fas fa-user"></i>
      Profil
    </a>
    <a class="dropdown-item" href="#">
      <i class="mr-1 fas fa-cogs"></i>
      Nastavitve
    </a>
    <a class="dropdown-item" href="#">
      <i class="mr-1 fas fa-life-ring"></i>
      Pomoč
    </a>
    <div class="dropdown-divider"></div>
    <a class="dropdown-item" href="#">
      <i class="mr-1 fas fa-sign-out-alt"></i>
      Odjava
    </a>-->
  </div>
</template>

<script>
  module.exports = {
    name: 'ProfileDropdown'
  }
</script>

<style>
#topbar .dropdown-menu{
  border: none;
  margin-top:15px;
  padding-bottom:0;
}
.arrow.top {
  background-color:purple;
}
.arrow.top:after {
  left: auto;
  right: 32px;
}
.arrow.top:after {
  top: -13px;
}
.arrow:after {
  background-color: purple;
  border-top-left-radius: 0.25rem;
}

.arrow:after {
    pointer-events: none;
    position: absolute;
    content: "";
    height: 30px;
    width: 30px;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
}
</style>
